import React from 'react'
import {
  useNavigate } from 'react-router-dom'
import { trackCTAClick } from '../services/analytics'
import { scrollToLandingSection } from '../utils/landingNav'
import {
  Box,
  Flex,
  HStack,
  Button,
  Container,
  IconButton,
  useDisclosure,
  VStack,
  Drawer,
  Image,
  Portal,
} from '@chakra-ui/react'
import { LuBookOpen, LuMenu } from 'react-icons/lu'

const Header = () => {
  const { open, onOpen, onClose } = useDisclosure()
  const navigate = useNavigate()

  const goToProducto = () => {
    trackCTAClick('producto', 'header')
    scrollToLandingSection('producto', navigate)
    onClose()
  }

  const goToPlanes = () => {
    trackCTAClick('planes', 'header')
    scrollToLandingSection('planes', navigate)
    onClose()
  }

  return (
    <Box bg="white" position="sticky" top={0} zIndex={1000} boxShadow="sm">
      <Container maxW="7xl">
        <Flex h={20} alignItems="center" justifyContent="space-between">
          <HStack gap={3} alignItems="center" cursor="pointer" onClick={() => navigate('/')}>
            <Image
              src="/logo y texto cadencya.png"
              alt="Cadencya"
              h={{ base: '55px', md: '80px' }}
              w="auto"
            />
          </HStack>

          <HStack gap={2} display={{ base: 'none', md: 'flex' }}>
            <Button
              variant="ghost"
              colorPalette="purple"
              fontWeight="600"
              color="purple.700"
              _hover={{ bg: 'purple.50' }}
              rounded="full"
              onClick={goToProducto}
            >
              Producto
            </Button>
            <Button
              variant="ghost"
              colorPalette="purple"
              fontWeight="600"
              color="purple.700"
              _hover={{ bg: 'purple.50' }}
              rounded="full"
              onClick={() => {
                trackCTAClick('comunidad', 'header')
                navigate('/comunidad')
              }}
            >
              Comunidad
            </Button>
            <Button
              variant="ghost"
              colorPalette="purple"
              fontWeight="600"
              color="purple.700"
              _hover={{ bg: 'purple.50' }}
              rounded="full"
              onClick={goToPlanes}
            >
              Planes
            </Button>
            <IconButton
              aria-label="Descargar manual de usuario"
              variant="ghost"
              colorPalette="purple"
              rounded="full"
              onClick={() => {
                trackCTAClick('manual_pdf', 'header')
                window.open('/manual-usuario-cadencya.pdf?v=20260927', '_blank', 'noopener,noreferrer')
              }}
            >
              <LuBookOpen />
            </IconButton>
            <Button
              variant="ghost"
              colorPalette="gray"
              fontWeight="600"
              color="gray.700"
              _hover={{ bg: 'gray.100' }}
              rounded="full"
              onClick={() => {
                trackCTAClick('iniciar_sesion', 'header')
                navigate('/login')
              }}
            >
              Iniciar sesión
            </Button>
            <Button
              bg="purple.600"
              color="white"
              fontWeight="700"
              _hover={{ bg: 'purple.700' }}
              rounded="full"
              px={6}
              onClick={() => {
                trackCTAClick('empezar_gratis', 'header')
                navigate('/registro?tipo=banda')
              }}
            >
              Empezar gratis
            </Button>
          </HStack>

          <IconButton
            size="md"
            aria-label="Open Menu"
            display={{ base: 'flex', md: 'none' }}
            onClick={onOpen}
            variant="ghost"
            rounded="full"
          >
            <LuMenu />
          </IconButton>

          <Drawer.Root
            open={open}
            placement="end"
            onOpenChange={(e) => {
              if (!e.open) onClose()
            }}
          >
            <Portal>
              <Drawer.Backdrop />
              <Drawer.Positioner>
                <Drawer.Content>
                  <Drawer.CloseTrigger />
                  <Drawer.Body pt={20}>
                    <VStack gap={4} align="stretch">
                      <Button variant="ghost" size="lg" colorPalette="purple" fontWeight="600" onClick={goToProducto}>
                        Producto
                      </Button>
                      <Button
                        variant="ghost"
                        size="lg"
                        colorPalette="purple"
                        fontWeight="600"
                        onClick={() => {
                          trackCTAClick('comunidad', 'header_mobile')
                          navigate('/comunidad')
                          onClose()
                        }}
                      >
                        Comunidad
                      </Button>
                      <Button variant="ghost" size="lg" colorPalette="purple" fontWeight="600" onClick={goToPlanes}>
                        Planes
                      </Button>
                      <Button
                        variant="ghost"
                        size="lg"
                        colorPalette="purple"
                        fontWeight="600"
                        onClick={() => {
                          trackCTAClick('manual_pdf', 'header_mobile')
                          window.open('/manual-usuario-cadencya.pdf?v=20260927', '_blank', 'noopener,noreferrer')
                          onClose()
                        }}
                      >
                        Manual de usuario
                      </Button>
                      <Button
                        variant="ghost"
                        size="lg"
                        onClick={() => {
                          trackCTAClick('iniciar_sesion', 'header_mobile')
                          navigate('/login')
                          onClose()
                        }}
                      >
                        Iniciar sesión
                      </Button>
                      <Button
                        bg="purple.600"
                        color="white"
                        size="lg"
                        onClick={() => {
                          trackCTAClick('empezar_gratis', 'header_mobile')
                          navigate('/registro?tipo=banda')
                          onClose()
                        }}
                      >
                        Empezar gratis
                      </Button>
                    </VStack>
                  </Drawer.Body>
                </Drawer.Content>
              </Drawer.Positioner>
            </Portal>
          </Drawer.Root>
        </Flex>
      </Container>
    </Box>
  )
}

export default Header
